import './HistogramTooltip.css';
export var wrapper = '_fzvydv0-3-5-0';